import React from 'react';
import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import { Button, IconButton, Table, TableBody, TableCell, TableHead, TableRow, Tooltip } from '@mui/material';

import { Icon, ResponsiveDialog, useSettings } from 'app/main/components';
import { ViewTableUtils } from 'app/main/components/page-layouts';

import { showSkillsEvaluationsEditDialog } from '../skills-evaluations/SkillsEvaluationsEditDialog';

interface SkillsUsersTableDetailsDialogProps {
	open: boolean;
	onClose: VoidFunction;
	model: any;
	updateRefresh?: VoidFunction;
}

export default function SkillsUsersTableDetailsDialog(props: SkillsUsersTableDetailsDialogProps) {
	const dispatch = useDispatch();
	const { t } = useSettings();
	const intl = useIntl();

	function addNewEvaluation() {
		dispatch(
			showSkillsEvaluationsEditDialog({
				model: {
					skev_skll_uid: props.model.skll_uid,
					skev_user_assigned_uid: props.model.user_uid
				},
				isAdd: true,
				updateRefresh: () => {
					props.onClose();
					props.updateRefresh?.();
				}
			})
		);
	}

	return (
		<ResponsiveDialog
			open={props.open}
			onClose={props.onClose}
			maxWidth="sm"
			title={intl.formatMessage(
				{ id: 'skillsUsersDetailsDialog.title', defaultMessage: t('SKILLS_USERS_DIALOG_DETAILS_TITLE') },
				{ user: props.model?.user_title, skill: props.model?.skll_title }
			)}
			headerAction={
				<Tooltip title={t('SKILLS_USERS_DIALOG_DETAILS_ACTION_ADD')} arrow>
					<IconButton onClick={addNewEvaluation}>
						<Icon icon="add-circle" />
					</IconButton>
				</Tooltip>
			}
			content={
				<Table size="small">
					<TableHead>
						<TableRow>
							<TableCell>{t('DETAILS_SKILLS_EVALUATIONS_FIELD_LEVEL')}</TableCell>
							<TableCell align="right">{t('DETAILS_SKILLS_EVALUATIONS_FIELD_DATE_FROM')}</TableCell>
							<TableCell align="right">{t('DETAILS_SKILLS_EVALUATIONS_FIELD_DATE_TO')}</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{props.model?.ussk_evaluations?.map(skillEval => (
							<TableRow
								key={skillEval.skev_uid}
								sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
							>
								<TableCell component="th" scope="row">
									{ViewTableUtils.renderPercentage({ value: skillEval.skev_level, digits: 0 })}
								</TableCell>
								<TableCell align="right">
									{ViewTableUtils.renderDate({ value: skillEval.skev_d_from })}
								</TableCell>
								<TableCell align="right">
									{ViewTableUtils.renderDate({ value: skillEval.skev_d_to })}
								</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			}
			actions={<Button onClick={props.onClose}>{t('DIALOG_ACTION_CLOSE')}</Button>}
		/>
	);
}
